@if (initialized) {
  <ng-container *ngIf="activeStep == 1">
    <login-otp-request (onStepComplete)="handleStepComplete($event)" (onSelectOption)="handleSelectOption($event)">
    </login-otp-request>
  </ng-container>

  <ng-container *ngIf="activeStep == 2">
    <login-otp-email
      (onStepComplete)="handleStepComplete($event)" (onEnteredContact)="handleEnteredContact($event)">
    </login-otp-email>

  </ng-container>
  <ng-container *ngIf="activeStep == 3">
    <login-otp-phone
      (onStepComplete)="handleStepComplete($event)" (onEnteredContact)="handleEnteredContact($event)">
    </login-otp-phone>
  </ng-container>

  <ng-container *ngIf="activeStep == 4">
    <login-otp-field
      [enteredContact]="enteredContact"
      [option]="selectedOption"
      (onStepComplete)="handleStepComplete($event)">
    </login-otp-field>
  </ng-container>

}
